import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';
import { AppState } from 'services/types';
import { SprayEventEntityId } from 'services/sprayEvents/types';
import VarietyName from 'components/VarietyName';
import { VarietyId } from 'services/varieties/types';
import { makeSelectVariety } from './selectors';

export interface OwnProps {
    entityId: SprayEventEntityId;
}

interface ConnectedProps {
    varietyId?: VarietyId | null;
}

type Props = OwnProps & ConnectedProps;

export class EntityTableRowVarietyCellComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { varietyId } = this.props;

        return (
            <TableCell textAlign="left" className="events-table-cell-padding">
                {varietyId && <VarietyName varietyId={varietyId} />}
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    varietyId: makeSelectVariety()
});

export default connect(mapStateToProps)(EntityTableRowVarietyCellComponent);
